import { atom } from "recoil";

import { supportedLanguages } from "utils/languages";
const queryParams = new URLSearchParams(window.location.search);

const lang = queryParams.get("lang");

console.log(lang, localStorage.getItem("language"));

export const currentLanguageRecoil = atom({
  key: "currentLanguageRecoil",
  default:
    lang ||
    localStorage.getItem("language") ||
    Object.keys(supportedLanguages)[0], // Initial value
});
